<div class="section-container flex justify-center flex-col">
    <div class="text-section flex items-center">
        <div class="text-title flex flex-col">
            <span class="title">Leadership</span>
            <span class="sub-title">guides the vision.</span>
        </div>
        <div class="content">A team of experienced leaders steering the vision with clarity, integrity, and bold thinking. They set the tone, then members follow with purpose.</div>
    </div>
    <div class="leader-section flex justify-center">
        <div class="leader-first">
            <img class="leader-desktop" src="../../../assets/images/about-us/hongdar-teng.png" />
            <img class="item leader-tablet" src="../../../assets/images/about-us/hongdar-teng-tablet.png" />
        </div>
        <div class="leader-second grid grid-cols-2 grid-rows-2 gap-[16px]">
            <img src="../../../assets/images/about-us/alex-yang.png" />
            <img src="../../../assets/images/about-us/turbo-lei.png" />
            <img src="../../../assets/images/about-us/amanda-yang.png" />
            <img src="../../../assets/images/about-us/charlotte-zheng.png" />
        </div>
    </div>
    <div class="leader-section-mobile flex flex-col justify-center gap-[16px]">
        <img src="../../../assets/images/about-us/hongdar-teng-mobile.png" />
        <img src="../../../assets/images/about-us/alex-yang-mobile.png" />
        <img src="../../../assets/images/about-us/turbo-lei-mobile.png" />
        <img src="../../../assets/images/about-us/amanda-yang-mobile.png" />
        <img src="../../../assets/images/about-us/charlotte-zheng-mobile.png" />
    </div>
</div>
